import React from 'react';
import classnames from 'classnames';

// Types
import { Attachment } from 'Shared/types/Attachment.type';

const DEFAULT_OPTIONS = {
  controls: true,
};

type Props = {
  attachment: Attachment;
  className?: string;
  options?: {
    controls?: boolean;
  };
};

const VideoPlayer = ({ attachment, className = '', options = DEFAULT_OPTIONS }: Props) => {
  const baseClassName = 'VideoPlayer';
  const classes = classnames(baseClassName, className);

  return (
    <video controls={options.controls} className={classes}>
      <source src={attachment.url} type={attachment.contentType} />
    </video>
  );
};

export default VideoPlayer;
